import { MARKER_START} from './MarkerStartTypes'

const initialState = {
    markerStart: ""
}

const markerStartReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case MARKER_START:
            
            return {
                markerStart: action.load
            }
    
        default:
          return state
    }

}


export default markerStartReducer;